"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'videoComponent',
  props: {
    datas: Object
  },
  data: function data() {
    return {
      resPath: process.env.VUE_APP_IMAGE_PATH || '',
      naturalW: 0,
      // 视频原始宽度（px），loadedmetadata 后才有值
      naturalH: 0,
      // 视频原始高度（px）
      containerW: 0 // 容器实际渲染宽度（px），mounted/resize 后更新
    };
  },
  computed: {
    reqPath: function reqPath() {
      return this.resPath;
    },
    videoElStyle: function videoElStyle() {
      var style = {};
      var hasBg = !!this.datas.bgSrc;
      var mt = this.datas.marginTop;
      var ml = this.datas.marginLeft;
      if (hasBg) {
        // 有背景图：宽高按百分比（宽度相对容器，高度再按视频原始比例缩放）
        var wPercent = this.datas.videoWidth || 100;
        var hPercent = this.datas.videoHeight || 100;
        if (this.containerW && this.naturalW && this.naturalH) {
          var w = this.containerW * wPercent / 100;
          var h = w * this.naturalH / this.naturalW * hPercent / 100;
          style.width = Math.round(w) + 'px';
          style.height = Math.round(h) + 'px';
        } else {
          // 元信息未就绪时回退，保证不溢出
          style.width = wPercent + '%';
          style.height = 'auto';
          style.maxWidth = '100%';
        }
        // 视频悬浮于背景图上，偏移量相对容器
        style.position = 'absolute';
        style.top = mt ? mt + '%' : '0';
        style.left = ml ? ml + '%' : '0';
        return style;
      }

      // 无背景图：宽高按 px，0 表示自适应
      if (this.datas.videoWidth > 0) {
        style.width = this.datas.videoWidth + 'px';
        // 防止设置超过容器宽度时溢出
        style.maxWidth = '100%';
      } else {
        style.width = '100%';
      }
      if (this.datas.videoHeight > 0) {
        style.height = this.datas.videoHeight + 'px';
      }
      if (mt) style.marginTop = mt + '%';
      if (ml) style.marginLeft = ml + '%';
      return style;
    }
  },
  mounted: function mounted() {
    this.measureContainer();
    window.addEventListener('resize', this.measureContainer);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.measureContainer);
  },
  methods: {
    measureContainer: function measureContainer() {
      var el = this.$refs.container;
      if (el) this.containerW = el.clientWidth;
    },
    onVideoMeta: function onVideoMeta(e) {
      var target = e.target;
      this.naturalW = target && target.videoWidth || 0;
      this.naturalH = target && target.videoHeight || 0;
      // metadata 就绪后重新测量，确保 containerW 已知
      this.measureContainer();
    }
  }
};